import { GROUP_ERRORS } from "../group/group-errors.js";

export const POST_ERRORS = {
	NOT_FOUND: "post_not_found",
	FORBIDDEN: "post_forbidden",
	INVALID_SCHEDULE_DATE: "invalid_schedule_date",
	GROUP_NOT_FOUND: GROUP_ERRORS.NOT_FOUND,
	ALREADY_LIKED: "post_already_liked",
	NOT_LIKED: "post_not_liked",
	POLL_ALREADY_VOTED: "poll_already_voted",
	POLL_NOT_FOUND: "poll_not_found",
	POLL_OPTION_NOT_FOUND: "poll_option_not_found",
	FAILED_TO_CREATE_POST: "failed_to_create_post",
	FAILED_TO_UPDATE_POST: "failed_to_update_post",
	FAILED_TO_PIN_POST: "failed_to_pin_post",
	FAILED_TO_UNPIN_POST: "failed_to_unpin_post",
	FAILED_TO_CREATE_POLL_VOTE: "failed_to_create_poll_vote",
	FAILED_TO_CREATE_POLL: "failed_to_create_poll",
	NOT_GROUP_MEMBER: GROUP_ERRORS.NOT_MEMBER,
	INVALID_STATUS_TRANSITION: "invalid_status_transition",
	AI_REFINE_FAILED: "ai_refine_failed",
} as const;

export type PostErrorCode = (typeof POST_ERRORS)[keyof typeof POST_ERRORS];
